import classnames from "classnames"
import React, { useEffect, useState } from "react"
import {
  useIsFetching as useIsQuerying,
  useIsMutating
} from "@tanstack/react-query"

const ReactQuerySeleniumTools = () => {
  const [busyCount, setBusyCount] = useState(0)

  const queriesCount = useIsQuerying()
  const mutationsCount = useIsMutating()
  const requestsCount = queriesCount + mutationsCount

  const [isIdle, setIsIdle] = useState(requestsCount === 0)

  useEffect(() => {
    /**
     * @type {string | number | NodeJS.Timeout | undefined}
     */
    let timer

    if (requestsCount > 0) {
      setIsIdle(false)
    } else if (!isIdle) {
      timer = setTimeout(() => {
        setIsIdle(true)

        setBusyCount((count) => count + 1)
      }, 250)
    }

    return () => clearTimeout(timer)
  }, [isIdle, requestsCount])

  return (
    <div
      className={classnames("react-query-selenium-tools", {
        "react-query-busy": !isIdle,
        "react-query-idle": isIdle
      })}
      data-busy-count={busyCount}
    />
  )
}

export default ReactQuerySeleniumTools
